import { Component, OnInit, Inject, ChangeDetectionStrategy} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { ModelsService } from '../models-new/models.service';
import { IrbAppEvents } from '@irb/app.events';
import { IModel, IModelDelete } from '@irb/irb-clients/irb-clients.model';
import { Subscription, interval } from 'rxjs';

@Component({ standalone: false,
  selector: 'irb-delete-model-dialog',
  templateUrl: './delete-model-dialog.component.html',
  styleUrls: ['./delete-model-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class DeleteModelDialogComponent implements OnInit {
  deleteModels: Array<any>;
  portfoliodeleteModels:any=[];
  portfoliosType = false;
  assignedToNoOfBlendedModels = false;
  notAssignedToPortfolioAndBlended =false;
  portfolioErrorMessage:String;
  blendedErrorMessage:String; 
  blendedDeleteModels:any=[]; 
  checkDeleteSelectedModelSub: Subscription;
  isUiTest = false;

 constructor(public dialogRef: MatDialogRef<DeleteModelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public mdd: any,
    private as: AppService,
    private modelService: ModelsService) {

  }

  ngOnInit(): void {
    this.deleteModels = this.mdd.deleteModels.selectedIds as Array<IModel>;
    this.checkModelType(this.deleteModels);
  }
  
  checkModelType(modelType: Array<any>) {
    for (let i = 0; i < modelType.length; i++) {

      if (modelType[i].portfolioListCount > 0) {
        let portfolioDataArray:any=[];
        this.portfoliosType = true;
        this.notAssignedToPortfolioAndBlended = false;
        portfolioDataArray.push(modelType[i].name);
        portfolioDataArray.push(modelType[i].description);
        this.portfoliodeleteModels.push(portfolioDataArray);
        this.portfolioErrorMessage = "The models listed below cannot be deleted because they are assigned to a portfolio.";
      }
      else if (modelType[i].assignedToNoOfBlendedModels > 0) {
        let blendedDataArray:any=[];
        this.assignedToNoOfBlendedModels = true;
        this.notAssignedToPortfolioAndBlended = false;
        blendedDataArray.push(modelType[i].name);
        blendedDataArray.push(modelType[i].description);
        this.blendedDeleteModels.push(blendedDataArray);
        this.blendedErrorMessage = "The models listed below cannot be deleted because they are assigned to a blended model.";
      }
      else {
        this.notAssignedToPortfolioAndBlended = true;

      }
    }

  }

  close() {
    if(this.dialogRef.close != undefined) {
     this.dialogRef.close();
    }
  }

  deleteSelectedModel() {
    let constModel: any[] = [];
    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);

    this.deleteModels.forEach((element: any)=>{
      constModel.push( {
        type:element.type,
        isDraft: element.isDraft,
        status: element.status,
        modelId:element.modelId,
        approvedModelId: element.approvedModelId,
        securityModelId:element.securityModelId,
        blendedSecurityModelId:element.blendedSecurityModelId,
        isSubscribed: element.isSubscribed,
        modelMarketId:element.modelMarketId,
      })
    });

    this.modelService.deleteSelectedModel(constModel).subscribe(res => {
      this.checkDeleteSelectedModelStatus(res.responseUtilityMap.statusId);
    }, () => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    });
  }

  checkDeleteSelectedModelStatus(statusId: string) {
   const intervalValue = this.isUiTest ? 0 : 3000;
    this.checkDeleteSelectedModelSub = interval(intervalValue).subscribe(() => {
      this.modelService.getDeleteSelectedModelStatus(statusId).subscribe((res: any) => {
        if(res.responseStatus.toUpperCase() === "SUCCESS") {
          if (res.responseData && res.responseData.reqStatus) {
            const reqStatus = res.responseData.reqStatus.toUpperCase();
            if (reqStatus === 'COMPLETED') {
              this.checkDeleteSelectedModelSub.unsubscribe();
              this.completeDeleteSelectedModel(res);
            }
          }
        }
      });
    });
  }

  completeDeleteSelectedModel(_res: any) {
    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
   
    this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
      severity: 'warn',
      summary: "",
      detail: this.deleteModels.length + " Model(s) were deleted."
    });

    this.as.fireEvent(IrbAppEvents.GRID_REFRESH);    
    this.close();
  }
}
